import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../Partial/Header";
import Footer from "../Partial/Footer";
import { BASE_IMAGE_URL, BASE_URL } from "../config";
import LoaderOverlay from '../Partial/LoaderOverlay';


const AboutUs = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  

  useEffect(() => {
    axios
      .post(`${BASE_URL}/cms-page-content`, {
        page_slug: "about-us",
      })
      .then((response) => {
        if (response.data && response.data.status === 200) {
          const data = response.data.data;
          setTitle(data.page_title);
          setContent(data.page_content || "");
          setImageUrl(`${BASE_IMAGE_URL}/${data.featured_image}`);
        } else {
          setError("Failed to load content.");
        }
      })
      .catch((err) => {
        console.error("Error fetching About Us content:", err);
        setError("Something went wrong.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      {loading && <LoaderOverlay />}
      <Header />
      <section className="searchcontainer">
        <span className="seachpattern">
          <svg
            width="525"
            height="454"
            viewBox="0 0 525 454"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M524.996 -2.76343H-356.388M524.996 59.5334H-356.388M524.996 121.83H-356.388M524.996 184.127H-356.388M524.996 246.424H-356.388M524.996 308.721H-356.388M524.996 371.018H-356.388M524.996 433.315H-356.388M473.582 453.426L473.582 -6.8772M399.749 453.426L399.749 -6.8772M325.916 453.426L325.916 -6.8772M252.083 453.426L252.082 -6.8772M178.25 453.426L178.249 -6.8772M104.417 453.426L104.417 -6.8772M30.584 453.426L30.584 -6.8772M-43.249 453.426V-6.8772M-117.082 453.426V-6.8772M-190.915 453.426V-6.8772M-264.748 453.426V-6.8772M-338.581 453.426V-6.8772"
              stroke="url(#paint0_linear_87_29)"
              strokeOpacity="0.08"
            />
            <defs>
              <linearGradient
                id="paint0_linear_87_29"
                x1="-223.192"
                y1="337.222"
                x2="217.544"
                y2="163.201"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="white" stopOpacity="0" />
                <stop offset="0.5" stopColor="white" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </span>
        <span className="seachpattern seachpatternrt">
          <svg
            width="525"
            height="454"
            viewBox="0 0 525 454"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M524.996 -2.76343H-356.388M524.996 59.5334H-356.388M524.996 121.83H-356.388M524.996 184.127H-356.388M524.996 246.424H-356.388M524.996 308.721H-356.388M524.996 371.018H-356.388M524.996 433.315H-356.388M473.582 453.426L473.582 -6.8772M399.749 453.426L399.749 -6.8772M325.916 453.426L325.916 -6.8772M252.083 453.426L252.082 -6.8772M178.25 453.426L178.249 -6.8772M104.417 453.426L104.417 -6.8772M30.584 453.426L30.584 -6.8772M-43.249 453.426V-6.8772M-117.082 453.426V-6.8772M-190.915 453.426V-6.8772M-264.748 453.426V-6.8772M-338.581 453.426V-6.8772"
              stroke="url(#paint0_linear_87_29)"
              strokeOpacity="0.08"
            />
            <defs>
              <linearGradient
                id="paint0_linear_87_29"
                x1="-223.192"
                y1="337.222"
                x2="217.544"
                y2="163.201"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="white" stopOpacity="0" />
                <stop offset="0.5" stopColor="white" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </span>
        <div className="container"></div>
      </section>

      {/* <section class="about-hero">
        <div class="container">
          <h1>About Us</h1>
          <p>
            Our capacitors are designed to endure harsh conditions, from extreme
            temperatures to tough environments, providing reliability you can
            trust.
          </p>
          <p class="small">
            In early 2024, our tenacious team of solutions-driven experts
            designed an EMP-proof, durable capacitor that stands up to the
            rigors of outdoor environments. If you’re searching for a capacitor
            you thought was long out of service, RCA capacitors are here to meet
            your needs. With cutting-edge technology and relentless innovation,
            we are redefining the possibilities of capacitor performance.
          </p>
        </div>
      </section> */}
      <section className="about-hero">
        <div className="container about-flex">
          {loading && <p>Loading...</p>}
          {error && <p className="error">{error}</p>}

          {!loading && !error && (
            <>
              
              <div className="about-content">
                <h1>{title}</h1>
                {/* {imageUrl && (
                  <img src={imageUrl} alt="About Us" />
                )} */}
                <div
                  className="cms-content"
                  dangerouslySetInnerHTML={{ __html: content }}
                ></div>
              </div>
            </>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default AboutUs;
